<script setup lang="ts">
import { PopoverPortal, PopoverContent } from 'radix-vue'
import { useAttrs } from 'vue'

const props = defineProps<{
  sideOffset?: number
  side?: 'top' | 'right' | 'bottom' | 'left'
  align?: 'start' | 'center' | 'end'
  collisionPadding?: number | Partial<Record<'top' | 'bottom' | 'left' | 'right', number>>
  avoidCollisions?: boolean
  class?: string
}>()

const attrs = useAttrs()

const handleWheel = (event: WheelEvent) => {
  event.stopPropagation()
  const isScrollingDown = event.deltaY > 0
  const key = isScrollingDown ? 'ArrowDown' : 'ArrowUp'
  const keyboardEvent = new KeyboardEvent('keydown', { key })
  event.currentTarget?.dispatchEvent(keyboardEvent)
}
</script>

<template>
  <PopoverPortal>
    <PopoverContent
      :side="props.side ?? 'bottom'"
      :side-offset="props.sideOffset ?? 10"
      :align="props.align ?? 'center'"
      :collision-padding="props.collisionPadding"
      :avoid-collisions="props.avoidCollisions ?? true"
      :class="[
        'max-h-[var(--radix-popper-available-height)] min-w-60 overflow-hidden rounded-md border p-2.5 text-sm shadow-md dark:shadow-xl',
        'border-gray-200 dark:border-gray-700',
        'text-gray-900 dark:text-gray-50',
        'bg-white dark:bg-gray-950',
        'will-change-[transform,opacity]',
        'data-[state=closed]:animate-hide',
        'data-[state=open]:data-[side=bottom]:animate-slideDownAndFade',
        'data-[state=open]:data-[side=left]:animate-slideLeftAndFade',
        'data-[state=open]:data-[side=right]:animate-slideRightAndFade',
        'data-[state=open]:data-[side=top]:animate-slideUpAndFade',
        props.class,
      ]"
      tremor-id="tremor-raw"
      v-on="attrs"
      @wheel="handleWheel"
    >
      <slot />
    </PopoverContent>
  </PopoverPortal>
</template>
